import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tabs, Table, Tooltip, InputNumber } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import axios from 'axios';
import { maskDate } from "../utils/Masker";
import moment from "moment-timezone";
import numeral from "numeral";
import PessoaFrame from './PessoaFrame';
import { getUsuario, getTemPermissao } from "../utils/LoginManager";

const { Item: ItemForm } = Form;
const TabPane = Tabs.TabPane;
const { Column } = Table;
const ButtonGroup = Button.Group;

export const OPCOES_TURNO = [
  { key: 'TURNO 01', label: 'TURNO 01' },
  { key: 'TURNO 02', label: 'TURNO 02' },
  { key: 'TURNO 03', label: 'TURNO 03' },
  { key: 'TURNO 04', label: 'TURNO 04' },
]



export default class AnaliseProducaoForm extends Component {
  state = {
    registro: {
      ap_idf: 0,
      ap_idf_pedido: 0,
      ap_idf_producao: 0,
      ap_usuario: { key: '0', label: '' },
      ap_cliente: { key: '0', label: '' },
      ap_produto: { key: '0', label: '' },
      ap_num_lote: '',
      ap_controle: '',
      ap_data_amostras: moment().format('DD/MM/YYYY'),
      ap_data_fabricacao: moment().format('DD/MM/YYYY'),
      ap_data_validade: moment().format('DD/MM/YYYY'),
      ap_dias_validade: 0,
      ap_qtde_producao: 0,
      ap_laboratorio: '',
      ap_protocolo: '',
      ap_obs: '',
    },

    api_resultado: '',
    api_obs: '',

    produtoSelect: [],
    categoriaSelect: [],

    listaItens: [],
    modalProdutoVisible: false,
    modalListaVisible: false,

    carregandoForm: false,
    editando: false,
    visualizando: false,

    activeKey: "dados",
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {

      const usuario = getUsuario();

      this.setState({
        registro: this.props.registroSelecionado.dados,
        ap_cliente: this.props.registroSelecionado.dados.ap_cliente,
        ap_produto: this.props.registroSelecionado.dados.ap_produto,
        listaItens: this.props.registroSelecionado.listaItens ? this.props.registroSelecionado.listaItens : [],
        visualizando: this.props.registroSelecionado.dados.visualizando,
        usuario,
        editando: false,
        activeKey: "dados",
      }, () => {
        this.setState({
          ap_cliente: {
            key: this.props.registroSelecionado.dados.ap_cliente.key,
            label: this.props.registroSelecionado.dados.ap_cliente.label
          },
          ap_produto: {
            key: this.props.registroSelecionado.dados.ap_produto.key,
            label: this.props.registroSelecionado.dados.ap_produto.label
          },
        });
        this.buscaCategorias();
        this.buscaProdutos();
      });

      if (this.props.registroSelecionado.dados.ap_idf) {
        this.setState({
          editando: true,
          activeKey: "dados",
        });
      }
    }
  }

  componentDidMount() {
    // const usuario = getUsuario();
    // this.setState({
    //   usuario,
    // });
  }

  onOK = () => {
    if ((!this.state.registro.ap_data_amostras) || (!moment(this.state.registro.ap_data_amostras, 'DD/MM/YYYY', true).isValid())) {
      Modal.warning({ title: 'Aviso!', content: 'Informe uma Data de Amostra Válida' });
      return;
    }
    if ((!this.state.registro.ap_data_fabricacao) || (!moment(this.state.registro.ap_data_fabricacao, 'DD/MM/YYYY', true).isValid())) {
      Modal.warning({ title: 'Aviso!', content: 'Informe uma Data de Fabricação Válida' });
      return;
    }
    if ((!this.state.registro.ap_data_validade) || (!moment(this.state.registro.ap_data_validade, 'DD/MM/YYYY', true).isValid())) {
      Modal.warning({ title: 'Aviso!', content: 'Informe uma Data de Validade Válida' });
      return;
    }
    if ((!this.state.registro.ap_cliente) || (this.state.registro.ap_cliente.key === '0') || (this.state.registro.ap_cliente.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Cliente', });
      return;
    }
    if ((!this.state.registro.ap_produto) || (this.state.registro.ap_produto.key === '0') || (this.state.registro.ap_produto.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Produto', });
      return;
    }
    if ((!this.state.listaItens) || (this.state.listaItens.length === 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Inclua algum item na Análise de Produção' });
      return;
    }

    const registro = {
      ...this.state.registro,
      ap_idf: this.state.registro.ap_idf,
      ap_data_amostras: moment(this.state.registro.ap_data_amostras, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      ap_data_fabricacao: moment(this.state.registro.ap_data_fabricacao, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      ap_dias_validade: this.state.registro.ap_dias_validade ? this.state.registro.ap_dias_validade : 0,
      ap_data_validade: moment(this.state.registro.ap_data_validade, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      ap_cliente: this.state.ap_cliente.key,
      ap_produto: this.state.ap_produto.key,
      ap_categoria: this.state.ap_categoria && this.state.ap_categoria.key ? this.state.ap_categoria.key : null,
      ap_protocolo: this.state.ap_protocolo && this.state.ap_protocolo.key ? this.state.ap_protocolo.key : null,

      listaItens: this.state.listaItens,
    };

    this.props.onSalvarClick(registro);
  };




  buscaCategorias = () => {
    this.setState({ categoriaSelect: [] })
    axios.get('/categoriaAnaliseProducao/lista', {
    }).then(response => {
      const { data } = response;
      const categoriaSelect = data.map(regList => {
        return {
          key: regList.cap_idf,
          label: regList.cap_descricao,
        }
      });
      this.setState({
        categoriaSelect,
      })
    }).catch(error => {
      console.error(error.response);
    })
  };



  onChangeTabs = (activeKey) => {
    this.setState({ activeKey });
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  };

  onChangePessoa = event => {
    const { registro } = this.state;
    registro['ap_cliente'] = event.ap_cliente;
    this.setState(event);
  }

  onCadPessoaClick = () => {
    this.setState({
      modalListaVisible: true,
    });
  }

  onFecharModalLista = () => {
    this.setState({
      modalListaVisible: false,
    });
  }


  onChangeProduto = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro, produtoSelect } = this.state;
    registro[id] = value;
    const registroIndex = produtoSelect.findIndex(reg => String(reg.key) === String(event.target.value.key))
    registro["ap_qtde_producao"] = produtoSelect[registroIndex].pta_qtde_analisar;
    registro["ap_dias_validade"] = produtoSelect[registroIndex].pta_dias_validade;
    registro["ap_data_validade"] = moment(moment(moment(this.state.registro.ap_data_fabricacao, 'DD/MM/YYYY').format('YYYY-MM-DD')).add(produtoSelect[registroIndex].pta_dias_validade, 'days')).format('DD/MM/YYYY');
    this.setState({ [id]: value });
    // console.log('onChangeProduto', value)
    this.buscaItensAnalise(value.key);
  }

  onChangeDataFab = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro, produtoSelect } = this.state;
    registro[id] = value;
    if ((registro.ap_produto.key !== '0') && (registro.ap_produto.key !== '')) {
      const registroIndex = produtoSelect.findIndex(reg => String(reg.key) === String(registro.ap_produto.key))
      registro["ap_data_validade"] = moment(moment(moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')).add(produtoSelect[registroIndex].pta_dias_validade, 'days')).format('DD/MM/YYYY');
    }
    this.setState({ [id]: value });
  };


  onInputChangeDiasVal = event => {
    const value = event;
    const id = 'ap_dias_validade';
    const { registro } = this.state;
    registro[id] = value;
    registro["ap_data_validade"] = moment(moment(moment(this.state.registro.ap_data_fabricacao, 'DD/MM/YYYY').format('YYYY-MM-DD')).add(value, 'days')).format('DD/MM/YYYY');
    this.setState({
      [id]: value,
    });
  }

  onInputChangeQtdePrev = event => {
    const value = event;
    const id = 'ap_qtde_producao';
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  }



  renderValor = (valor) => {
    return (
      <span> {numeral(parseFloat(valor)).format('0,000.00')} </span>
    );
  };

  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }


  renderResultado = (data, registro) => {
    return (
      <Col xs={24} style={{ marginTop: -5, marginBottom: -30 }}>
        <InputForm
          id="api_resultado"
          ref="api_resultado"
          maxLength={20}
          value={registro.api_resultado}
          onChange={(value) => {
            registro.api_resultado = value.target.value;
            this.forceUpdate();
          }}
        />
      </Col>
    )
  }

  renderOBS = (data, registro) => {
    return (
      <Col xs={24} style={{ marginTop: -5, marginBottom: -30 }}>
        <InputForm
          id="api_obs"
          ref="api_obs"
          maxLength={20}
          value={registro.api_obs}
          onChange={(value) => {
            registro.api_obs = value.target.value;
            this.forceUpdate();
          }}
        />
      </Col>
    )
  }



  buscaProdutos = (value) => {
    this.setState({ produtoSelect: [] })
    const { gtp_idf } = this.state.registro;
    axios.get('/tiposAnalises/listaProdutos', {
    }).then(response => {
      const { data } = response;
      const produtoSelect = data.map(regList => {
        return {
          key: regList.pta_idf_produto,
          label: regList.prod_codigo + ' - ' + regList.prod_descricao,
          pta_dias_validade: regList.pta_dias_validade,
          pta_qtde_analisar: regList.pta_qtde_analisar,
        }
      });

      this.setState({
        produtoSelect,
      })

    }).catch(error => {
      console.error(error.response);
    })
  }

  buscaItensAnalise = (value) => {
    // console.log('buscaItensAnalise', value)
    this.setState({ listaItens: [] })
    const { gtp_idf } = this.state.registro;
    axios.get('/tiposAnalises/listaItensProdutos', {
      params: {
        produto: value,
        tipo: 'combo'
      }
    }).then(response => {
      const listaItens = response.data.map(regList => {
        return {
          api_idf_tipo_analise: regList.pta_idf_tipo_analise,
          api_seq_tipo_analise: regList.pta_seq_tipo_analise,
          api_resultado: '',
          api_obs: '',
          ta_descricao: regList.ta_descricao,
          tai_descricao: regList.tai_descricao,
          tai_min: regList.tai_min,
          tai_max: regList.tai_max,
          tai_obs: regList.tai_obs,
        }
      });

      this.setState({
        listaItens,
      })

    }).catch(error => {
      console.error(error.response);
    })
  }





  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------



  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { carregandoForm, listaItens, produtoSelect, categoriaSelect } = this.state;
    const { ap_idf, ap_idf_producao, ap_idf_pedido, op_numero, ven_numero, ap_data_amostras, ap_data_fabricacao, ap_data_validade, ap_cliente, ap_produto, ap_num_lote, ap_controle,
      ap_dias_validade, ap_qtde_producao, ap_peso_real, ap_categoria, ap_laboratorio, ap_protocolo, ap_obs } = this.state.registro;

    // console.log('AnaliseProducaoForm.this.state: ', this.state);

    return (
      <Modal
        title={ap_idf ? (this.state.visualizando ? "Análise Laboratorial" : "Edição Análise Laboratorial") : "Inclusão de Análise Laboratorial"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"80%"}
        style={{ top: 10 }}
      >

        <div>
          <Tabs
            type="card"
            activeKey={this.state.activeKey}
            onChange={this.onChangeTabs}
          >
            <TabPane tab="Dados Principais" key="dados">
              <div style={{ height: 450 }}>
                <Form>
                  <Row>
                    <div className="div-subTitulo">
                      <span style={{ marginLeft: 10, fontWeight: "bold", fontSize: 17 }}>
                        Dados da Análise de Produção
                      </span>
                    </div>

                    <Row>

                      <Col xs={24} sm={12} style={{ marginTop: 5, paddingRight: 20 }}>
                        <PessoaFrame
                          label="Cliente"
                          id="ap_cliente"
                          value={ap_cliente}
                          tipo="C"
                          width={"100%"}
                          onChange={this.onChangePessoa}
                          descricaoPrimeiroItem="Selecione um Cliente"
                          disabled={ap_idf || ap_idf_producao || ap_idf_pedido ? true : false}
                        />
                      </Col>

                      <Col xs={24} sm={12} style={{ marginTop: 5 }}>
                        <span>Produto</span>
                        <InputForm
                          type="select"
                          id="ap_produto"
                          ref="ap_produto"
                          value={ap_produto}
                          placeholder="Selecione"
                          onChange={this.onChangeProduto}
                          data={produtoSelect}
                          validator={value => Boolean(value)}
                          style={{ width: "100%" }}
                          showSearch
                          disabled={ap_idf || ap_idf_producao || ap_idf_pedido ? true : false}
                        />
                      </Col>

                      {/* <Col xs={24} sm={6} style={{ marginTop: 0, paddingRight: 20 }}>
                        <span>Data Amostra</span>
                        {ap_idf ? (
                          <InputForm
                            id="ap_data_amostras"
                            ref="ap_data_amostras"
                            value={ap_data_amostras}
                            readOnly
                          />
                        ) : (
                          <InputForm
                            type="date"
                            id="ap_data_amostras"
                            ref="ap_data_amostras"
                            value={ap_data_amostras}
                            masker={maskDate}
                            validator={data => moment(data, "DD/MM/YYYY", true).isValid()}
                            dateFormat="DD/MM/YYYY"
                            onChange={this.onChange}
                            errorMessage="Formato correto DD/MM/AAAA"
                            className="input-data-avaliacao"
                            style={{ width: "100%" }}
                            disabled={ap_idf ? true : false}
                          />
                        )}
                      </Col> */}


                      <Col xs={24} sm={4} style={{ marginTop: -20, paddingRight: 20 }}>
                        <span>Data Fabricação</span>
                        {/* {ap_idf ? (
                          <InputForm
                            id="ap_data_fabricacao"
                            ref="ap_data_fabricacao"
                            value={ap_data_fabricacao}
                            readOnly
                          />
                        ) : ( */}
                        <InputForm
                          type="date"
                          id="ap_data_fabricacao"
                          ref="ap_data_fabricacao"
                          value={ap_data_fabricacao}
                          masker={maskDate}
                          validator={data => moment(data, "DD/MM/YYYY", true).isValid()}
                          dateFormat="DD/MM/YYYY"
                          onChange={this.onChangeDataFab}
                          errorMessage="Formato correto DD/MM/AAAA"
                          className="input-data-avaliacao"
                          style={{ width: "100%" }}
                        // disabled={ap_idf ? true : false}
                        />
                        {/* )} */}
                      </Col>

                      {/* <Col xs={24} sm={6} style={{ marginTop: -15, paddingRight: 20 }}>
                      <span>Dias Validade</span>
                      <InputNumber
                        ref="Input"
                        id={ap_dias_validade}
                        value={ap_dias_validade}
                        onChange={this.onInputChangeDiasVal}
                        min={0}
                        max={999999}
                        maxLength={6}
                        style={{ width: '100%' }}
                      />
                    </Col> */}

                      <Col xs={24} sm={4} style={{ marginTop: -20, paddingRight: 20 }}>
                        <span>Data Validade</span>
                        <InputForm
                          id="ap_data_validade"
                          ref="ap_data_validade"
                          onChange={this.onChange}
                          value={ap_data_validade}
                          readOnly
                        />
                      </Col>


                      <Col xs={24} sm={4} style={{ marginTop: -20, paddingRight: 20 }}>
                        <span>Lote</span>
                        <InputForm
                          id="ap_num_lote"
                          ref="ap_num_lote"
                          maxLength={9}
                          onChange={this.onChange}
                          value={ap_num_lote}
                        />
                      </Col>

                      <Col xs={24} sm={4} style={{ marginTop: -20, paddingRight: 20 }}>
                        <span>Controle</span>
                        <InputForm
                          id="ap_controle"
                          ref="ap_controle"
                          maxLength={9}
                          onChange={this.onChange}
                          value={ap_controle}
                          disabled={ap_idf ? true : false}
                        />
                      </Col>

                      {ap_idf_pedido ? (
                        <Col xs={24} sm={4} style={{ marginTop: -20 }}>
                          <span>Pedido</span>
                          <InputForm
                            id="ven_numero"
                            ref="ven_numero"
                            maxLength={9}
                            onChange={this.onChange}
                            value={ven_numero}
                            readOnly
                          />
                        </Col>
                      ) : ap_idf_producao ? (
                        <Col xs={24} sm={4} style={{ marginTop: -20 }}>
                          <span>Ordem Produção</span>
                          <InputForm
                            id="op_numero"
                            ref="op_numero"
                            maxLength={9}
                            onChange={this.onChange}
                            value={op_numero}
                            readOnly
                          />
                        </Col>
                      ) : null}

                    </Row>


                    <Row>
                      <Col xs={24} sm={4} style={{ marginTop: -16, paddingRight: 20 }}>
                        <span>Qtde</span>
                        <InputNumber
                          ref="Input"
                          id={ap_qtde_producao}
                          value={ap_qtde_producao}
                          onChange={this.onInputChangeQtdePrev}
                          min={0}
                          max={999999}
                          maxLength={6}
                          style={{ width: '100%' }}
                          disabled={ap_idf || ap_idf_producao || ap_idf_pedido ? true : false}
                        />
                      </Col>

                      <Col xs={24} sm={4} style={{ marginTop: -16, paddingRight: 20 }}>
                        <span>Peso</span>
                        <InputNumber
                          ref="Input"
                          id={ap_peso_real}
                          value={ap_peso_real}
                          onChange={this.onInputChangeQtdePrev}
                          min={0}
                          max={999999}
                          maxLength={6}
                          style={{ width: '100%' }}
                          disabled={true}
                        />
                      </Col>

                      <Col xs={24} sm={4} style={{ marginTop: -20, paddingRight: 20 }}>
                        <span>Categoria</span>
                        <InputForm
                          type="select"
                          id="ap_categoria"
                          ref="ap_categoria"
                          value={ap_categoria}
                          placeholder="Selecione"
                          onChange={this.onChange}
                          data={categoriaSelect}
                          validator={value => Boolean(value)}
                          style={{ width: "100%" }}
                        />
                      </Col>

                      <Col xs={24} sm={4} style={{ marginTop: -20, paddingRight: 20 }}>
                        <span>Turno</span>
                        <InputForm
                          type="select"
                          id="ap_protocolo"
                          ref="ap_protocolo"
                          value={ap_protocolo}
                          placeholder="Selecione"
                          onChange={this.onChange}
                          data={OPCOES_TURNO}
                          validator={value => Boolean(value)}
                          style={{ width: "100%" }}
                        />
                      </Col>

                      <Col xs={24} sm={8} style={{ marginTop: -20 }}>
                        <span>Analista / Laboratório</span>
                        <InputForm
                          id="ap_laboratorio"
                          ref="ap_laboratorio"
                          value={ap_laboratorio}
                          maxLength={200}
                          onChange={this.onChange}
                          validator={value => Boolean(value)}
                          readOnly={true}
                        />
                      </Col>

                      <Col xs={24} style={{ marginTop: -20 }}>
                        <span>OBS</span>
                        <InputForm
                          id="ap_obs"
                          ref="ap_obs"
                          value={ap_obs}
                          maxLength={200}
                          onChange={this.onChange}
                          validator={value => Boolean(value)}
                        />
                      </Col>
                    </Row>

                  </Row>

                </Form>
              </div>
            </TabPane>


            <TabPane tab="Lista dos Itens" key="produtos">
              <div style={{ height: 450 }}>
                <Table
                  loading={{
                    spinning: carregandoForm,
                    tip: 'Carregando. Aguarde...',
                    size: "large"
                  }}
                  dataSource={listaItens}
                  pagination={false}
                  scroll={{ y: 450 }}
                  rowKey={(listaItens => listaItens.pi_item)}
                >
                  <Column
                    key="ta_descricao"
                    dataIndex="ta_descricao"
                    title="Tipo"
                    width={"20%"}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="tai_descricao"
                    dataIndex="tai_descricao"
                    title="Descrição"
                    width={"20%"}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="tai_min"
                    dataIndex="tai_min"
                    title="Min"
                    width={"10%"}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="tai_max"
                    dataIndex="tai_max"
                    title="Max"
                    width={"10%"}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="api_resultado"
                    dataIndex="api_resultado"
                    title="Resultado"
                    render={this.renderResultado}
                    width={"20%"}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="api_obs"
                    dataIndex="api_obs"
                    title="OBS"
                    render={this.renderOBS}
                    width={"25%"}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="acoes"
                    title=""
                    render={this.renderAcoesProdutos}
                    width={"15%"}
                    align="center"
                    className="listaCadastro"
                  />
                </Table>
              </div>
            </TabPane>

          </Tabs>
        </div>

        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizando ? null : (
                  <Button
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="botoesModalForm2x"
                  >
                    Salvar Análise
                  </Button>
                )}
                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AnaliseProducaoForm.js